import { toDateReadable } from '@gov-nx/utils/common';

export const selectedToReadable = (
	selected: Array<string | null>,
	options: { label: string; value: string }[],
	emptyText: string
): string => {
	if (!selected || selected.length === 0) {
		return emptyText;
	}
	return options
		.filter((option) => selected.includes(option.value))
		.map((option) => option.label)
		.join(', ');
};

interface SelectedDateOfValidityConsentToReadableParams {
	consentValidityInterval: 'URCITY' | 'NEURCITY';
	dateOfValidityConsent: Date | null | undefined;
	indefiniteText: string;
	emptyText: string;
}

export const selectedDateOfValidityConsentToReadable = ({
	consentValidityInterval,
	dateOfValidityConsent,
	indefiniteText,
	emptyText,
}: SelectedDateOfValidityConsentToReadableParams): string => {
	if (consentValidityInterval !== 'URCITY') {
		return indefiniteText;
	}

	if (!dateOfValidityConsent) {
		return emptyText;
	}

	return toDateReadable(dateOfValidityConsent);
};
